import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import OTP from '../../../components/OTP';
import { AuthAPI } from '../../../api';

const useStyles = makeStyles(theme => ({
  reminder: {
    marginTop: '0.75rem',
    marginBottom: '1.5rem',
    color: theme.palette.text.secondary,
  },
}));

const PhoneVerifyForm = ({ phone, title, onVerified, onChangeNumber }) => {
  const classes = useStyles();

  const verified = useRef(null);

  const handleComplete = (code) =>
    AuthAPI.verifyPhoneOtp(phone, code, true).then(({ payload }) => {
      verified.current = payload;
    });

  const handleSuccess = () => {
    const result = verified.current;
    if (result) onVerified(result.username, result.code);
  };

  return (
    <div>
      <Typography variant="h1" color="primary">
        {title}
      </Typography>
      <Typography variant="body1" className={classes.reminder}>
        If the provided number is linked to a Clickability account, we&apos;ve sent it a 6 digit code.
      </Typography>
      <OTP
        phoneNumber={phone}
        onComplete={handleComplete}
        onSuccess={handleSuccess}
        onPhoneNumberClick={onChangeNumber}
        onCancel={onChangeNumber}
        cancelText="Use a different number"
      />
    </div>
  );
};

PhoneVerifyForm.propTypes = {
  phone: PropTypes.string.isRequired,
  title: PropTypes.string,
  onVerified: PropTypes.func.isRequired,
  onChangeNumber: PropTypes.func,
};

export default PhoneVerifyForm;
